import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-autocomplete-field-with-matform',
    templateUrl: './autocomplete-field-with-matform.component.html',
    styleUrls: ['./autocomplete-field-with-matform.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteFieldWithMatformComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class AutocompleteFieldWithMatformComponent implements OnInit, ControlValueAccessor {
  @Input() options: string[] = []; // Options for the autocomplete
  @Input() placeholder: string = "";
  @Input() isrequired = false;
  @Output() selectionChange = new EventEmitter<string>(); // Emits the selected option
  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;
  formControl = new FormControl('');
  filteredOptions!: Observable<string[]>;
  optionsfilter: string[] = [];
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    // Initialize filtering logic due to delay to get option value code written in ngOnChanges
    // this.filteredOptions = this.formControl.valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filter(value || ''))
    // );

    // Emit changes to ngModel whenever the form control value changes
    this.formControl.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }
  isvaluechanged=true;
  ngOnChanges(changes: any): void {
    if(this.isvaluechanged){
      if(this.options.length>0){
        this.isvaluechanged=false;
        setTimeout(() => {
          this.filteredOptions = this.formControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || ''))
          );
          this.isvaluechanged=true;
        }, 100);
      }
    }
  }
  // Write a new value to the element
  writeValue(value: any): void {
    this.formControl.setValue(value, { emitEvent: false });
  }

  // Set the function to be called when the control receives a change event
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Set the function to be called when the control receives a touch event
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  // Private method to filter options based on input value
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  
  onOptionSelected(option: string) {
    this.selectionChange.emit(option); // Emit selected option
  }
  validateSelection(): void {
    const currentValue = this.formControl.value;
    if(currentValue !== undefined && currentValue !== null && currentValue !== ''){
      setTimeout(() => {
        const currentValue = this.formControl.value;
        if (!this.options.includes(currentValue)) {
            this.formControl.setValue(''); // Clear the input if the value is invalid
        }
        this.selectionChange.emit(currentValue);
      }, 500);
    }
  }
}
